import $api from "../../../axios"
import { IProjectDataKeywords } from "../types/projectDataKeywords.types"

const projectsPath = "/projects/keywords"

const getKeywordsData = async (projectId: string): Promise<IProjectDataKeywords[]> => {
  const response = await $api.get(projectsPath + "/", { params: { projectId } })
  return response.data
}

const addKeyword = async (
  projectId: string,
  keywords: string[]
): Promise<IProjectDataKeywords[]> => {
  const response = await $api.post(projectsPath + "/addKeywords", { projectId, keywords })
  return response.data
}

export default {
  getKeywordsData,
  addKeyword,
}
